import React, { ChangeEvent, forwardRef, useState } from 'react';
import classNames from 'classnames';
import { filterMembersBy } from '../../../../../../forms/helpers';
import { DropdownItem } from '../../../../../dropdown';
import HighlightMatches from '../../../../../highlight-matches';
import { Checkbox } from '../../../../../checkbox-or-radio-field';
import SearchInput from '../../../../../search-input';
import styles from '../../../../../../components/selectDeals/styles.module.scss';

const TeamMembersDropdown = forwardRef(
  (
    {
      children,
      dropdownId,
      onDealChange,
      dealChecked,
      dealValue,
      style,
      className,
      onClick,
      checkboxComponent: CheckboxComponent = Checkbox,
      currentUserId,
    }: any,
    ref: any
  ) => {
    const [query, setQuery] = useState('');

    const renderDealCheckboxes = () => (
      <>
        {children
          .filter((teamMember: any) => filterMembersBy(teamMember, query.trim()))
          .map((teamMember: any, index: number) => {
            const { fullName } = teamMember;
            const displayName = teamMember.id === currentUserId ? `${fullName} (you)` : fullName;
            // Use combination of id and index to ensure uniqueness
            const uniqueKey = `member-${teamMember.id}-${index}`;

            return (
              <DropdownItem key={uniqueKey} highlightable as="li">
                <CheckboxComponent
                  className="w-100"
                  type="checkbox"
                  id={`${dropdownId}.select-deal.${teamMember.id}`}
                  key={teamMember.id}
                  value={dealValue(teamMember)}
                  checked={dealChecked(teamMember)}
                  onChange={(e: any) => onDealChange(e, teamMember)}
                  label={
                    // @ts-ignore - HighlightMatches is a JSX component without TypeScript definitions
                    // To fix: Convert highlight-matches.jsx to TypeScript or create a .d.ts file
                    <HighlightMatches query={query.trim()}>{displayName}</HighlightMatches>
                  }
                />
              </DropdownItem>
            );
          })}
      </>
    );

    return (
      <div ref={ref} style={style} className={className} onClick={onClick}>
        <div className="p-2 d-flex bg-light align-items-center">
          <SearchInput
            autoFocus
            className="ml-3 w-auto"
            // @ts-ignore - SearchInput is a JavaScript component (index.js) without TypeScript definitions
            // The 'style' prop is valid but not typed. To fix: Convert search-input/index.js to TypeScript
            style={{ flex: 'auto' }}
            onChange={(e: ChangeEvent<HTMLInputElement>) => setQuery(e.currentTarget.value)}
            value={query}
            id={`${dropdownId}-query`}
            placeholder="Search Existing Team Member"
          />
        </div>
        <ul className={classNames(styles.resultsList, 'list-unstyled m-0')}>{renderDealCheckboxes()}</ul>
      </div>
    );
  }
);

export default TeamMembersDropdown;
